import { render, staticRenderFns } from "./PAShowHSNInfo.vue?vue&type=template&id=186ffbf3"
import script from "./PAShowHSNInfo.vue?vue&type=script&lang=js"
export * from "./PAShowHSNInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports